import { render, staticRenderFns } from "./bounty-notice.vue?vue&type=template&id=7bfb86c1&scoped=true&lang=pug&"
import script from "./bounty-notice.vue?vue&type=script&lang=js&"
export * from "./bounty-notice.vue?vue&type=script&lang=js&"
import style0 from "./bounty-notice.vue?vue&type=style&index=0&id=7bfb86c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb86c1",
  null
  
)

export default component.exports